// Imports
import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

Vue.use(Router)
Vue.use(VueMeta)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
      {
        path: '/',
        name: 'Welcome',
        component: () => import('@/views/welcome/Index.vue'),
      },
      {
        path: '',
        name: 'Welcome',
        component: () => import('@/views/welcome/Index.vue'),
      },
      {
        path: '/main',
        name: 'Main',
        component: () => import('@/views/main/Index.vue'),
      },
      {
        path: '/news',
        name: 'News',
        component: () => import('@/views/news/Index.vue'),
      },
      {
        path: '/news/logo-contest',
        name: 'LogoContest',
        component: () => import('@/views/news/News-logo-contest.vue'),
      },
      {
        path: '/project/01',
        name: 'Project01',
        component: () => import('@/views/projects/project01.vue'),
      },
      {
        path: '/project/02',
        name: 'Project02',
        component: () => import('@/views/projects/project02.vue'),
      },
      {
        path: '/project/03',
        name: 'Project03',
        component: () => import('@/views/projects/project03.vue'),
      },
      {
        path: '/event',
        name: 'Event',
        component: () => import('@/views/event/Index.vue'),
      },
      {
        path: '/about',
        name: 'About',
        component: () => import('@/views/about/Index.vue'),
      },
      {
        path: '/contact-us',
        name: 'Contact',
        component: () => import('@/views/contact-us/Index.vue'),
      },
      {
        path: '*',
        name: 'FourOhFour',
        component: () => import('@/views/404/Index.vue'),
      },
      ],
})

export default router

